import config from "@/constants/releaseConfig.js";
import { switchTitle } from '@/utils/util.js';
export default [{
        title: '必考点90分，轻松助你拿下90分',
        name: 'answerFile/answer',
        params: "answerFile/answer/:id?"
    },
    {
        title: '必考点90分，轻松助你拿下90分',
        name: 'answerFile/answerAll',
        params: "answerFile/answerAll/:id?"
    },
    {
        title: '必考点90分，轻松助你拿下90分',
        name: 'answerFile/answer3',
        params: 'answerFile/answer3/:id?'
    },
    {
        title: '必考点90分，轻松助你拿下90分',
        name: 'answerIndex/answerIndex'
    },
    {
        title: '必考点90分，轻松助你拿下90分',
        name: 'answerIndex/answerIndex2'
    },
    {
        title: '必考点90分，轻松助你拿下90分',
        name: 'answerIndex/answerIndex4'
    },
    {
        title: '必考点90分，轻松助你拿下90分',
        name: 'answerIndex/answerIndex5'
    },
    {
        title: '必考点90分，轻松助你拿下90分',
        name: 'answerIndex/answerIndex6'
    },
    {
        title: '如何半小时拿下90分？消防必考点90分，速记抢分',
        name: 'answerIndex/answerIndex3',
        params: 'answerIndex/answerIndex3/:id?',
    },
    {
        title: '今日考题-2018年中级会计考题（原题重现）',
        name: 'subjectCollect/subjectCollect'
    },
    {
        title: '页面测试',
        name: 'subjectCollect/subjectCollectNew'
    },
    {
        title: '今日考题-2018年中级会计考题（原题重现）',
        name: 'subjectCollect/index'
    },
    {
        title: '今日考题-2018年中级会计考题（原题重现）',
        name: 'subjectCollect/upSubject'
    },
    {
        title: '2018下半年教师资格密训押题，考前通关捷径',
        name: 'teacher/teacherExam'
    },
    {
        title: '2019初级护师',
        name: 'teacher/primaryNurse'
    },
    {
        title: '2019主管护师',
        name: 'teacher/supervisorNurse'
    },
    {
        title: '2019护士执业',
        name: 'teacher/practitionerNurse'
    },
    {
        title: '2019护士执业',
        name: 'teacher/Ashare'
    },
    {
        title: '2019护士执业',
        name: 'teacher/practitioner'
    },
    {
        title: '执业药师300个必考点，速记抢分！',
        name: 'allAnswer/allAnswer',
        params: 'allAnswer/allAnswer/:id(\\d+)',
        props: (route) => ({
            subjectList: [{
                    name: '药事管理与法规',
                    id: '111'
                },
                {
                    name: '药学专业知识（一）',
                    id: '112'
                },
                {
                    name: '药学专业知识（二）',
                    id: '113'
                },
                {
                    name: '药学综合知识与技能',
                    id: '114'
                },
                {
                    name: '中药学专业知识（一）',
                    id: '115'
                },
                {
                    name: '中药学专业知识（二）',
                    id: '116'
                },
                {
                    name: '中药学综合知识与技能',
                    id: '117'
                }
            ],
            shareContent: {
                id: '177',
                title: '如何半小时拿下90分？药考300个必考点，速记抢分！',
                msg: '资料多，看不完？别慌，这里汇总了300个必考点，掌握它90分已入囊中！',
                icon: 'https://resource.oss.yatiku.com/activity%2FanswerFile%2Fshare_icon.jpg',
                url: `${config.remoteOrigin}/redirect_42_${route.query.accId}_1_${route.query.subjectId}_${route.query.adminUserWxId}`
            }
        })
    },
    {
        title: '消防必考点90分，速记抢分',
        name: 'allAnswer/allAnswer',
        params: 'allAnswer/xfAnswer/:id?',
        props: (route) => ({
            subjectList: [{
                    name: '消防安全技术实务',
                    id: '107'
                },
                {
                    name: '消防安全技术综合能力',
                    id: '108'
                },
                {
                    name: '消防安全案例分析',
                    id: '110'
                },
            ],
            shareContent: {
                id: '190',
                title: '如何半小时拿下90分？消防必考点90分，速记抢分【免费参加，刻不容缓】',
                msg: '资料多，看不完？不用慌，名师严选精准必考点，免费领取，助你快速通关消防考试',
                icon: 'https://resource.oss.yatiku.com/activity/answerFile/test2/share.jpg',
                url: ''
            }
        })
    },
    {
        title: switchTitle(localStorage.getItem('pharmacistAnswerId')),
        name: 'allAnswer/pharmacist'
    },
    {
        title: switchTitle(localStorage.getItem('pharmacistAnswerId2020')),
        name: 'allAnswer/pharmacist2020'
    },
    {
        title: '考前小抄',
        name: 'allAnswer/pharmacist2021'
    },
    {
        title: '主管护师最后三页纸（升级版）',
        name: 'allAnswer/pharmacist2021GS'
    },
    {
        title: '2021主管护师考试最后三页纸',
        name: 'allAnswer/pharmacist2021GS2'
    },
    {
        title: '2021护士考试最后三页纸（升级版）',
        name: 'allAnswer/pharmacist2021GS3'
    },
    {
        title: '2021护士考试最后三页纸（考后升级版）',
        name: 'allAnswer/pharmacist2021GS4'
    },
    {
        title: '2021初级会计最后三页纸（考后升级版）',
        name: 'allAnswer/pharmacist2021GS6'
    },
    {
        title: '2021二级建造师最后三页纸（考后升级版）',
        name: 'allAnswer/pharmacist2021GS7'
    },
    {
        title: '免费领！升级版考前三页纸',
        name: 'allAnswer/pharmacist2021GS8'
    },
    {
        title: '2021初级会计最后三页纸',
        name: 'allAnswer/pharmacist2021GS5'
    },
    {
        title: '考前小抄',
        name: 'allAnswer/pharmacist2021east'
    },
    {
        title: '考前小抄',
        name: 'allAnswer/pharmacist2021west'
    },
    {
        title: '考前小抄',
        name: 'allAnswer/pharmacy'
    },
    {
        title: '考前小抄',
        name: 'allAnswer/nurse2020'
    },
    {
        title: '考前小抄',
        name: 'allAnswer/physician'
    },
    {
        title: '考前小抄',
        name: 'allAnswer/architect2020'
    },
    {
        title: '2019执业药师密押考点',
        name: 'allAnswer/answerIndex/answerIndex'
    },
    {
        title: '2019执业药师密押考点',
        name: 'allAnswer/answerIndex2/answerIndex'
    },
    {
        title: '执业医师必考点大爆料',
        name: 'allAnswer/2020pharmacistAnswer/answerIndex'
    },
    {
      title: '2020初级会计必考点90分',
      name: 'allAnswer/2020accountAnswer/answerIndex'
    },
    {
      title: '2020护理【必考点大爆料】，助你轻松提分',
      name: 'allAnswer/2020xuehuliAnswer/answerIndex'
    },
    {
      title: '2020护理【必考点大爆料】，助你轻松提分',
      name: 'allAnswer/2020xuehuliAnswer/pharmacistAnswer'
    },
    {
        title: '2020二级建造【必考点大爆料】，助你轻松提分',
        name: 'allAnswer/2020jianzaoAnswer/answerIndex'
      },
      {
        title: '2020二级建造【必考点大爆料】，助你轻松提分',
        name: 'allAnswer/2020jianzaoAnswer/pharmacistAnswer'
      },
    {
        title: '2019执业药师密押考点',
        name: 'allAnswer/answerIndex/pharmacistAnswer'
    },
    {
        title: '2019执业药师密押考点',
        name: 'allAnswer/answerIndex2/pharmacistAnswer'
    },
    {
        title: '执业医师必考点大爆料',
        name: 'allAnswer/2020pharmacistAnswer/pharmacistAnswer'
    },
    {
      title: '2020初级会计必考点90分',
      name: 'allAnswer/2020accountAnswer/pharmacistAnswer'
    },
    {
        title: '教师考试大爆料，揭密300个密押考点，快速拿下90分',
        name: 'teacherQua/TeacherIndex'
    },
    {
        title: '必考点90分，轻松助你拿下90分',
        name: 'teacherQua/answerFile/answer'
    },
    {
        title: '【完整版】2018年经济师考试真题及估分',
        name: 'economist/economist'
    },
    {
        title: '【全网首发】2019上半年教师资格考试真题答案及解析',
        name: 'teacherPage/teacherPage'
    },
    {
        title: '题目列表',
        name: 'teacherPage/resultPage'
    },
    {
        title: '【消防完整版】2018年一级消防工程师考试真题及答案估分',
        name: 'fireControl/fireControl',
        params: 'fireControl/fireControl/:id?'
    },
    {
        title: '2019初级会计职称考试真题对答案',
        name: 'accountPage/index'
    },
    {
        title: '2019初级会计职称考试真题对答案',
        name: 'accountPage/tab'
    },
    {
        title: '咨询页面',
        name: 'consultation/consultation'
    },
    {
        title: '咨询页面',
        name: 'consultation/consultation2'
    },
    {
        title: '咨询页面',
        name: 'consultation/consultation3'
    },
    {
        title: '分享',
        name: 'consultation/sharePage'
    },
    {
        title: '考点错题',
        name: 'errorPoint/index'
    },
    {
        title: '考点错题',
        name: 'errorPoint/index2'
    },
    {
        title: '教师结构化50题！面试稳稳过',
        name: 'examQa/index'
    },
    {
        title: '教师结构化50题！面试稳稳过',
        name: 'examQa/qaList'
    },
    {
        title: '答案',
        name: 'examQa/qaDetail'
    },
    {
        title: '教师面试',
        name: 'examQa/teacherInterview/index'
    },
    {
        title: '教师面试',
        name: 'examQa/teacherInterview/qaList'
    },
    {
        title: '答案',
        name: 'examQa/teacherInterview/qaDetail'
    },
    {
        title: '考前抢分，争分夺秒必刷！',
        name: 'nurseAnswer/nurseAnswer',
        props: (route) => ({
            subjectList: [{
                    name: '护士执业资格考试',
                    subjects: [{
                        "id": 74,
                        "name": "护士执业资格考试"
                    }],
                    subjectArr: [74]
                },
                {
                    name: "初级护师",
                    subjects: [{
                        "id": 72,
                        "name": "初级护师"
                    }],
                    subjectArr: [72]
                },
                {
                    name: "主管护师",
                    subjects: [{
                            "id": 1602,
                            "name": "儿科护理学"
                        },
                        {
                            "id": 1603,
                            "name": "外科护理学"
                        },
                        {
                            "id": 1604,
                            "name": "内科护理学"
                        },
                        {
                            "id": 1605,
                            "name": "妇产科护理学"
                        },
                        {
                            "id": 1606,
                            "name": "社区护理学"
                        }
                    ],
                    subjectArr: [1602, 1603, 1604, 1605, 1606]
                }
            ],
            shareContent: {
                id: '177',
                title: '临考最后一根救命稻草，30分钟轻松拿下90分！ ',
                msg: '临考前最后一套！命题名师力荐！掌握它90分已收入囊中！',
                icon: 'https://resource.oss.yatiku.com/activity/examQa/hushi_kaodian/share.png'
            }
        })
    },
    {
        title: '考前抢分，争分夺秒必刷！',
        name: 'nurseAnswer/index'
    },
    {
        title: '选择考试场次',
        name: 'trueQuestion/TrueQueSceneList'
    },

    {
        title: '真题对答案',
        name: 'trueQuestion/TrueQuestionList'
    },
    {
        title: '押题神话',
        name: 'trueQuestion/TrueActivityPage1'
    },
    {
        title: '学员好评',
        name: 'trueQuestion/TrueActivityPage2'
    },

    // 护士资格证书
    {
        title: '选择考试场次',
        name: 'nurseQualification/TrueQueSceneList'
    },
    {
        title: '真题对答案',
        name: 'nurseQualification/TrueQuestionList'
    },
    {
        title: '2019护士/初级护师/主管护师【真题答案及解析】（最全最准）',
        name: 'nurseQualification/pageIndex1'
    },
    {
        title: '必考点90分，轻松助你拿下90分',
        name: 'fireAnswer/index'
    },
    {
        title: '必考点90分，轻松助你拿下90分',
        name: 'fireAnswer/answer'
    },


    {
        title: '真题对答案',
        name: 'trueQuestion2/TrueQueSceneList'
    },
    {
        title: '真题对答案',
        name: 'trueQuestion2/TrueQuestionList'
    },
    {
        title: '押题神话',
        name: 'trueQuestion2/TrueActivityPage1'
    },
    {
        title: '学员好评',
        name: 'trueQuestion2/TrueActivityPage2'
    },
    {
        title: '真题对答案',
        name: 'trueQuestion2/TrueAnswerQuestionPage'
    },

    {
        title: '真题对答案',
        name: 'trueQuestion3/TrueQueSceneList'
    },
    {
        title: '真题对答案',
        name: 'trueQuestion3/TrueQuestionList'
    },
    {
        title: '真题对答案',
        name: 'trueQuestion3/TrueAnswerQuestionPage'
    },
    // 2020初级会计真题对答案
    {
        title: '真题对答案',
        name: 'trueQuestion4/TrueQueSceneList'
    },
    {
        title: '真题对答案',
        name: 'trueQuestion4/TrueQuestionList'
    },
    {
        title: '真题对答案',
        name: 'trueQuestion4/TrueAnswerQuestionPage'
    },
    // 2021初级会计真题对答案
    {
        title: '真题对答案',
        name: 'trueQuestion4_cjkj/TrueQueSceneList'
    },
    {
        title: '真题对答案',
        name: 'trueQuestion4_cjkj/TrueQuestionList'
    },
    {
        title: '真题对答案',
        name: 'trueQuestion4_cjkj/TrueAnswerQuestionPage'
    },
    // 中级会计真题对答案
    {
        title: '真题对答案',
        name: 'trueQuestion5/TrueQueSceneList'
    },
    {
        title: '真题对答案',
        name: 'trueQuestion5/TrueQuestionList'
    },
    {
        title: '真题对答案',
        name: 'trueQuestion5/TrueAnswerQuestionPage'
    },

     // 护士护师真题对答案
     {
        title: '真题对答案',
        name: 'trueQuestion6/TrueQueSceneList'
    },
    {
        title: '真题对答案',
        name: 'trueQuestion6/TrueQuestionList'
    },

    // 护士资格证书
    {
        title: '选择考试场次',
        name: 'nurseQualification/TrueQueSceneList'
    },
    {
        title: '真题对答案',
        name: 'nurseQualification/TrueQuestionList'
    },
    {
        title: '真题对答案',
        name: 'nurseQualification/pageIndex1'
    },
    {
        title: switchTitle(localStorage.getItem('teacherAnswerId')),
        name: 'allAnswer/teacher'
    },
    {
        title: "鸭题库",
        name: 'allAnswer/fireControl'
    },

    // 教师真题对答案
    {
        title: '真题对答案',
        name: 'teacherTrueQuestion/TrueQueSceneList'
    },

    {
        title: '真题对答案',
        name: 'teacherTrueQuestion/TrueQuestionList'
    },
    {
        title: '真题对答案',
        name: 'teacherTrueQuestion/TrueAnswerQuestionPage'
    },


    // 消防真题对答案
    {
        title: '真题对答案',
        name: 'fireTrueQuestion/TrueQueSceneList'
    },

    {
        title: '真题对答案',
        name: 'fireTrueQuestion/TrueQuestionList'
    },
    {
        title: '真题对答案',
        name: 'fireTrueQuestion/TrueAnswerQuestionPage'
    },

    // 章节练习
    {
        title: '章节练习',
        name: 'chapterExercises/chapterExercises'
    },

    // 健康管理师真题对答案
    {
        title: '2019健康管理师考试',
        name: 'healthTrueQuestion/TrueQueSceneList'
    },

    {
        title: '2019健康管理师考试',
        name: 'healthTrueQuestion/TrueQuestionList'
    },

    {
        title: '2019健康管理师考试',
        name: 'healthTrueQuestion/TrueAnswerQuestionPage'
    },
     // 药考真题对答案
     {
        title: '真题对答案',
        name: 'trueQuestion7/TrueQueSceneList'
    },
    {
        title: '真题对答案',
        name: 'trueQuestion7/TrueQuestionList'
    },

    // 一级建造师真题对答案
    {
        title: '真题对答案',
        name: 'trueQuestion8/TrueQueSceneList'
    },
    {
        title: '真题对答案',
        name: 'trueQuestion8/TrueQuestionList'
    },
    // 药学职称
    {
        title: '真题对答案',
        name: 'trueQuestion9/TrueQueSceneList'
    },
    {
        title: '真题对答案',
        name: 'trueQuestion9/TrueQuestionList'
    },
]



// WEBPACK FOOTER //
// ./src/route/answerRouter.js